import Transaction from '@/generated/classes/Transaction';
export default class TransactionExtend extends Transaction {
  constructor() {
    super();
  }
}
